import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får funktionshindrade extra tid på kunskapsprovet?";
const SHORT_ANSWER = "Ja. Kommunen kan bevilja anpassningar som förlängd tid, uppläst prov eller tekniska hjälpmedel.";

export const Route = createFileRoute("/fraga/far-funktionshindrade-extra-tid")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får funktionshindrade extra tid på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Ansök om anpassning hos kommunen vid bokning och bifoga underlag (intyg från läkare/psykolog). Beslutet är individuellt och dokumenteras i ansökan."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – tillgänglighet" }}
      related={[{"to": "/fraga/ar-provet-svart", "label": "Är kunskapsprovet svårt?"}, {"to": "/fraga/hur-pluggar-jag-effektivt", "label": "Hur pluggar jag effektivt inför kunskapsprovet?"}, {"to": "/fraga/vilken-paragraf-styr-kunskapsprovet", "label": "Vilken paragraf styr kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får funktionshindrade extra tid på kunskapsprovet?" },
      { name: "description", content: "Ja. Kommunen kan bevilja anpassningar som förlängd tid, uppläst prov eller tekniska hjälpmedel." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-funktionshindrade-extra-tid" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-funktionshindrade-extra-tid" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-funktionshindrade-extra-tid",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får funktionshindrade extra tid på kunskapsprovet", url: "https://alkoholprovet.se/fraga/far-funktionshindrade-extra-tid" },
      ]),
    ],
  }),
});
